// The browser supplies the multipart boundary. JSON remains the default for other requests.
export const requestHeaders = (headers: Headers, body: unknown) => {
    if (body instanceof FormData) headers.delete('Content-Type');
    return headers;
};
